import { render, staticRenderFns } from "./TextareaAutosize.vue?vue&type=template&id=6a896d4e&scoped=true&"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js&"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js&"
import style0 from "./TextareaAutosize.vue?vue&type=style&index=0&id=6a896d4e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a896d4e",
  null
  
)

export default component.exports